import React from 'react'

import FieldProto from "../../../../proto/field-proto"
import {FieldViewSize} from "../../../../const"


type Props = {
    className?  : string

    size?       : FieldViewSize

    field       : FieldProto
    value       : any
    model?      : any
    options?    : any

    disabled?   : boolean

    onChange?   : callback
}

// const debug = "FieldPopover_FormComponent"
const debug = false

export default class FieldPopover_FormComponent extends React.Component<Props,any> {

    public previousValue        : any

    constructor(props:Props) {
        super(props);

        this.state = {
            currentValue    : props.value,
            showPopover     : false,
        }

        debug && console.log(debug, 'constructor', this.state)
    }

    // required to update current value if props value changed
    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if (prevProps.value !== this.props.value) {
            this.setState({
                currentValue: this.props.value,
            })
        }
    }

    showPopover = () => {
        if (!this.state.showPopover && !this.props.disabled) {
            this.setState({
                showPopover: true
            })
        }
    }

    hidePopover = () => {
        debug && console.log(debug, 'hidePopover', this.state.showPopover)

        if (this.state.showPopover) {
            this.setState({
                showPopover: false
            })
        }
    }

    onValueChange = (newValue: any, hidePopover: boolean = true) => {
        debug && console.log(debug, 'onValueChange', newValue, hidePopover)

        this.previousValue = this.state.currentValue

        this.setState({
            currentValue: newValue
        }, () => {
            this.props.onChange?.(newValue, this.onCancelChange)
            if (hidePopover) {
                this.hidePopover()
            }
        })
    }

    onReset = () => {
        this.onValueChange(null, true)
    }

    onOptionClick = (option:any) => {
        const newValue = _.get(option, 'value', null)
        this.onValueChange(newValue)
    }

    onCancelChange = () => {
        this.setState({
            currentValue: this.previousValue
        })
    }

    render() {
        const {field} = this.props
        const classes = Classes(this.props.className, {
            'show-popover' : this.state.showPopover,
        })

        debug && console.log(debug, 'render', this.state.showPopover)

        // need check value because of none
        if (!_.isNil(this.state.currentValue) && (!Array.isArray(this.state.currentValue) || !_.isEmpty(this.state.currentValue))) {
            return (
                <field.components.FormValueNotEmpty
                    className   = {classes}
                    field       = {field}
                    options     = {this.props.options}
                    size        = {this.props.size}
                    value       = {this.state.currentValue}
                    disabled    = {this.props.disabled}
                    onClick     = {this.showPopover}
                    onReset     = {this.onReset}
                    onChange    = {this.onValueChange}
                >
                    {this.state.showPopover &&
                        <field.components.PopoverMenu
                            {...this.props}
                            parent  = {this}
                            value   = {this.state.currentValue}
                        />
                    }
                </field.components.FormValueNotEmpty>
            );
        } else {
            return (
                <field.components.FormValueEmpty
                    className   = {classes}
                    field       = {field}
                    size        = {this.props.size}
                    disabled    = {this.props.disabled}
                    onClick     = {this.showPopover}
                >
                    {this.state.showPopover &&
                        <field.components.PopoverMenu
                            {...this.props}
                            parent  = {this}
                        />
                    }
                </field.components.FormValueEmpty>
            )
        }
    }
}
